import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const ProductDescription = ({ product }) => {
  return (
    <>
      {product.name && (
        <Typography.Paragraph
          style={{
            fontSize: 16,
            marginTop: 16
          }}
        >
          {product.name}
        </Typography.Paragraph>
      )}
    </>
  );
};

ProductDescription.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

export default ProductDescription;
